import * as ambassadorWixWixpressCookieBannerSettingsV1CookieBannerSettings from './wixpress-cookie-banner-settings-v1-cookie-banner-settings-cookie-banner-settings.http.js';
import * as ambassadorWixWixpressCookieBannerSettingsV1CookieBannerSettingsTypes from './wixpress-cookie-banner-settings-v1-cookie-banner-settings-cookie-banner-settings.types.js';
import * as ambassadorWixWixpressCookieBannerSettingsV1CookieBannerSettingsUniversalTypes from './wixpress-cookie-banner-settings-v1-cookie-banner-settings-cookie-banner-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function installCookieBanner(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixWixpressCookieBannerSettingsV1CookieBannerSettingsUniversalTypes.InstallCookieBannerRequest,
  ambassadorWixWixpressCookieBannerSettingsV1CookieBannerSettingsTypes.InstallCookieBannerRequest,
  ambassadorWixWixpressCookieBannerSettingsV1CookieBannerSettingsUniversalTypes.InstallCookieBannerResponse,
  ambassadorWixWixpressCookieBannerSettingsV1CookieBannerSettingsTypes.InstallCookieBannerResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixWixpressCookieBannerSettingsV1CookieBannerSettings.installCookieBanner(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/cookie-banner-installation',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCookieBannerSettings(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixWixpressCookieBannerSettingsV1CookieBannerSettingsUniversalTypes.GetCookieBannerSettingsRequest,
  ambassadorWixWixpressCookieBannerSettingsV1CookieBannerSettingsTypes.GetCookieBannerSettingsRequest,
  ambassadorWixWixpressCookieBannerSettingsV1CookieBannerSettingsUniversalTypes.GetCookieBannerSettingsResponse,
  ambassadorWixWixpressCookieBannerSettingsV1CookieBannerSettingsTypes.GetCookieBannerSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixWixpressCookieBannerSettingsV1CookieBannerSettings.getCookieBannerSettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/cookie-banner-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCookieBannerSettings(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixWixpressCookieBannerSettingsV1CookieBannerSettingsUniversalTypes.UpdateCookieBannerSettingsRequest,
  ambassadorWixWixpressCookieBannerSettingsV1CookieBannerSettingsTypes.UpdateCookieBannerSettingsRequest,
  ambassadorWixWixpressCookieBannerSettingsV1CookieBannerSettingsUniversalTypes.UpdateCookieBannerSettingsResponse,
  ambassadorWixWixpressCookieBannerSettingsV1CookieBannerSettingsTypes.UpdateCookieBannerSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixWixpressCookieBannerSettingsV1CookieBannerSettings.updateCookieBannerSettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/cookie-banner-settings/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  CookieBannerSettings as CookieBannerSettingsOriginal,
  PrivacyPolicyDetailsReferenceType as PrivacyPolicyDetailsReferenceTypeOriginal,
  PrivacyPolicyDetailsReferenceTypeWithLiterals as PrivacyPolicyDetailsReferenceTypeWithLiteralsOriginal,
  SlugDetails as SlugDetailsOriginal,
  ExternalPageUrlDetails as ExternalPageUrlDetailsOriginal,
  ButtonPosition as ButtonPositionOriginal,
  ButtonPositionWithLiterals as ButtonPositionWithLiteralsOriginal,
  SiteColor as SiteColorOriginal,
  CornerRadius as CornerRadiusOriginal,
  CornerRadiusWithLiterals as CornerRadiusWithLiteralsOriginal,
  Audience as AudienceOriginal,
  AudienceWithLiterals as AudienceWithLiteralsOriginal,
  DeclineAllConfig as DeclineAllConfigOriginal,
  PrivacyPolicyType as PrivacyPolicyTypeOriginal,
  PrivacyPolicyTypeWithLiterals as PrivacyPolicyTypeWithLiteralsOriginal,
  Theme as ThemeOriginal,
  ThemeWithLiterals as ThemeWithLiteralsOriginal,
  RevisitSettingsConfig as RevisitSettingsConfigOriginal,
  CustomThemeConfig as CustomThemeConfigOriginal,
  PrivacyPolicyPageInfo as PrivacyPolicyPageInfoOriginal,
  PrivacyPolicyPageInfoDetailsOneOf as PrivacyPolicyPageInfoDetailsOneOfOriginal,
  GetCookieBannerPreviewSettingsRequest as GetCookieBannerPreviewSettingsRequestOriginal,
  GetCookieBannerPreviewSettingsResponse as GetCookieBannerPreviewSettingsResponseOriginal,
  SetCookieBannerPreviewSettingsRequest as SetCookieBannerPreviewSettingsRequestOriginal,
  SetCookieBannerPreviewSettingsResponse as SetCookieBannerPreviewSettingsResponseOriginal,
  DeleteCookieBannerPreviewSettingsRequest as DeleteCookieBannerPreviewSettingsRequestOriginal,
  DeleteCookieBannerPreviewSettingsResponse as DeleteCookieBannerPreviewSettingsResponseOriginal,
  GetChannelPermissionsRequest as GetChannelPermissionsRequestOriginal,
  Channel as ChannelOriginal,
  Subscriber as SubscriberOriginal,
  GetChannelPermissionsResponse as GetChannelPermissionsResponseOriginal,
  InstallCookieBannerRequest as InstallCookieBannerRequestOriginal,
  ConsentPolicy as ConsentPolicyOriginal,
  InstallCookieBannerResponse as InstallCookieBannerResponseOriginal,
  GetCookieBannerSettingsRequest as GetCookieBannerSettingsRequestOriginal,
  GetCookieBannerSettingsResponse as GetCookieBannerSettingsResponseOriginal,
  SetCookieBannerSettingsRequest as SetCookieBannerSettingsRequestOriginal,
  SetCookieBannerSettingsResponse as SetCookieBannerSettingsResponseOriginal,
  UpdateCookieBannerSettingsRequest as UpdateCookieBannerSettingsRequestOriginal,
  UpdateCookieBannerSettingsResponse as UpdateCookieBannerSettingsResponseOriginal,
} from './wixpress-cookie-banner-settings-v1-cookie-banner-settings-cookie-banner-settings.types.js';
